import { useEffect } from 'react'
import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import { App } from '@capacitor/app'
import { isNative } from '@/lib/capacitor'
import { useToast } from '@/providers/ToastProvider'

export function usePushNotificationListeners(): void {
  const { showToast } = useToast()

  useEffect(() => {
    if (!isNative()) return
    if (!Capacitor.isPluginAvailable('PushNotifications')) return

    const foregroundListener = PushNotifications.addListener(
      'pushNotificationReceived',
      (notification) => {
        const title = notification.title || 'Notification'
        const body = notification.body ? `: ${notification.body}` : ''
        showToast(`${title}${body}`, 'info', 5000)
      }
    )

    const tapListener = PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (_action) => {
        // Future: navigate based on action.notification.data
      }
    )

    const appStateListener = App.addListener('appStateChange', (state) => {
      if (state.isActive) {
        PushNotifications.removeAllDeliveredNotifications()
      }
    })

    return () => {
      foregroundListener.then((h) => h.remove())
      tapListener.then((h) => h.remove())
      appStateListener.then((h) => h.remove())
    }
  }, [showToast])
}
